import * as THREE from 'three'
import gsap from 'gsap'
import { CustomEase } from "gsap/CustomEase"
import Experience from "../Experience.js"

export default class razor {
    constructor() {
        this.experience = new Experience()
        this.scene = this.experience.scene
        this.resources = this.experience.resources
        this.time = this.experience.time
        this.debug = this.experience.debug

        //Debug
        if (this.debug.active) {
            this.debugFolder = this.debug.ui.addFolder('razor').close()
        }

        //Setup
        this.resource = this.resources.items.razorModel
        gsap.registerPlugin(CustomEase)

        this.setModel()
        this.setAnimation()
    }

    setModel () {
        this.model = this.resource.scene
        this.model.position.set(0, -2, 0)
        this.model.scale.set(5, 5, 5)
        this.model.rotation.y = Math.PI * .5

        this.handle = this.model.getObjectByName("LFRassorflat")
        this.icon = this.model.getObjectByName("LFicone001")
        this.base = this.model.getObjectByName("Base1")
        this.support1 = this.model.getObjectByName("Support01")
        this.support2 = this.model.getObjectByName("Support02")
        this.blade0 = this.model.getObjectByName("Blade")
        this.blade1 = this.model.getObjectByName("Blade1")
        this.blade2 = this.model.getObjectByName("Blade2")
        this.capot = this.model.getObjectByName("Capot1")
        this.screw = this.model.getObjectByName("Screw001")

        this.scene.add(this.model)


        this.model.traverse((child) => {
            if (child instanceof THREE.Mesh) {
                child.material.envMap = localStorage["theme-preference"] === 'light' ? this.resources.items.environmentMap : this.resources.items.environmentMapDark
                child.material.envMapIntensity = this.resources.items.envMapIntensity
                child.castShadow = true
                child.receiveShadow = true
                child.material.depthTest = true
                child.material.depthWrite = true
                child.frustumCulled = false;
            }
        })
        if (this.handle) {
            this.handle.scale.set(0.4, 0.4, 0.4)
            this.handle.position.y = .2

            gsap.to(this.handle.rotation, { delay: .6, duration: 2.5, ease: CustomEase.create("custom","M0,0 C0,0.281 0.166,0.538 0.324,0.686 0.516,0.866 0.758,0.96 1,1 "), y: '-=5' })
            gsap.to(this.handle.scale, { delay: .6, duration: 2.5, ease: CustomEase.create("custom", "M0,0,C0.258,0.64,0.253,0.643,0.296,0.714,0.446,0.962,0.7,0.984,1,1"), x: 1, y: 1, z: 1 })
            gsap.to(this.handle.position, { delay: .6, duration: 2.5, ease: CustomEase.create("custom", "M0,0,C0.258,0.64,0.253,0.643,0.296,0.714,0.446,0.962,0.7,0.984,1,1"), y: .6 })

        }
    }

    setAnimation () {
        this.animation = {}
        this.animation.mixer = new THREE.AnimationMixer(this.model)
        this.animation.action = this.animation.mixer.clipAction(this.resource.animations[0])
        this.animation.action.setLoop(THREE.LoopOnce)
        this.animation.action.clampWhenFinished = true

    }

    update () {
        this.animation.mixer.update(this.time.delta * 0.001)

        if (this.handle) {
            this.handle.rotation.y += this.experience.world.rotateChoice.value * this.time.delta * 0.001
            this.handle.rotation.y = this.handle.rotation.y % (2 * Math.PI)
        }
    }
}
